import { IComponentOptions } from 'angular';
import { RegentsPlanningTableTransferCtrl } from './regents-planning-table-transfer.controller';

export const RegentsPlanningTableTransferComponent: IComponentOptions = {
  bindings: {},
  controller: RegentsPlanningTableTransferCtrl,
  template: require('./regents-planning-table-transfer.html'),
};
